import { dateFormatter } from "@services/utils";
import Link from "next/link";
import Image from "next/image";
import React from "react";

type NewsProps = {
  slug: string;
  titre: string;
  description?: string;
  img: string;
  date: string;
};

const News: React.FC<NewsProps> = ({ slug, titre, img, date, description }) => {
  return (
    <Link href={`/article/${slug}`} passHref>
      <a className=" group">
        <div className=" h-full overflow-hidden rounded border-opacity-60 bg-darkAccent">
          {/* Photo de la news */}
          <div className="relative aspect-video w-full overflow-hidden rounded sm:h-64 ">
            <Image layout="fill" src={`https:${img}`} alt={`Image de couverture de l'article ${titre}`} title={`Image de couverture de l'article ${titre}`} objectFit="cover" placeholder="blur" blurDataURL={`https:${img}`} className="transform object-center transition duration-300 group-hover:scale-105" />
          </div>
          {/* Corps de la news */}
          <div className="flex flex-col items-stretch justify-center p-4">
            <span className="mb-1 text-sm font-medium tracking-widest text-redAccent opacity-80">{dateFormatter(date)}</span>
            <h1 className="mb-3 text-xl font-bold text-whiteAccent group-hover:underline lg:text-2xl">{titre}</h1>
            <p className="mb-3 text-whiteAccent/50 line-clamp-2">{description}</p>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default News;
